import { render, staticRenderFns } from "./BrigadeMapBrigadeInformationVehicle.vue?vue&type=template&id=66f454ec&"
import script from "./BrigadeMapBrigadeInformationVehicle.vue?vue&type=script&lang=js&"
export * from "./BrigadeMapBrigadeInformationVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QItem,QItemSection,QImg,QSpinnerGears,QItemLabel} from 'quasar'
component.options.components = Object.assign({QCard,QItem,QItemSection,QImg,QSpinnerGears,QItemLabel}, component.options.components || {})
